/**
 * @param {*} state
 * @param {*} payload
 */
export const retrieveSales = (state, payload) => {
  state.sales = payload.data
  state.pagination.links = payload.links
  state.pagination.meta = payload.meta
}

/**
 * @param {*} state
 * @param {*} payload
 */
export const editSale = (state, payload) => state.sale = payload

/**
 * @param {*} state
 * @param {*} data
 */
export const updateSale = (state, data) => {
  let index = state.sales.findIndex(sale => sale.id === data.id)

  state.sales.splice(index, 1, data)
}

/**
 * @param {*} state
 * @param {*} id
 */
export const updateDisabledStatus = (state, id) => {
  state.sales.find(sale => {
    if (sale.id === id) {
      sale.disabled = 'already_in_cart'
    }
  })
}

/**
 * @param {*} state
 * @param {*} id
 */
export const removeSale = (state, id) => {
  for (let index = 0; index < state.sales.length; index++) {
    if (state.sales[index].id === id) {
      state.sales.splice(index, 1)
    }
  }
}

/**
 * @param {*} state
 * @param {*} data
 */
export const retrieveClients = (state, data) => {
  state.clients = data
}

/**
 * @param {*} state
 * @param {*} data
 */
export const selectCotation = (state, data) => {
  state.sales.filter(sale => {
    if (sale.id === data.id) {
      sale.cotation = data.cotation
    }
  })
}

/**
 * @param {*} state
 * @param {*} data
 */
export const updateFilters = (state, data) => {
  switch (data.type) {
    case 'client':
      state.filters.client = data.value
      break;

    case 'limit':
      state.filters.limit = data.value
      break;

    case 'range':
      state.filters.range = data.value
      break;

    case 'page':
      state.filters.page = data.value
      break;

    default:
      state.filters.search = data.value
      break;
  }
}

/**
 * @param {*} state
 * @param {*} data
 */
export const pushItemIntoArray = (state, data) => state.selectedSales.push(data)

/**
 * @param {*} state
 * @param {*} data
 */
export const popItemFromArray = (state, data) => {
  let index = state.selectedSales.indexOf(data)

  state.selectedSales.splice(index,1)
}

/**
 * @param {*} state
 */
export const cleanArray = state => state.selectedSales.length = 0
